var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 17.975V9.50001H6.8V17.975H5.3ZM11.35 17.975V9.50001H12.85V17.975H11.35ZM2 20.975V19.475H22V20.975H2ZM17.2 17.975V9.50001H18.7V17.975H17.2ZM2 8.00001V6.67501L12 0.975006L22 6.67501V8.00001H2ZM5.35 6.50001H18.65L12 2.70001L5.35 6.50001Z",
    fill: "url(#paint0_linear_339_332)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_332",
    x1: 12,
    y1: 0.975011,
    x2: 12,
    y2: 20.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanco);
export default __webpack_public_path__ + "static/media/banco.4e9ee7d09e7d508a7ae084d1cca091f1.svg";
export { ForwardRef as ReactComponent };